<template>
  <div>
    <div class="page page__list" v-if="!isPC">
      <search-bar
        @search="onSearch"
        name="pr_code,pr_detail,pr_orispeccode,pr_brand"
        placeholder="输入产品编号、名称、型号、品牌进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/document/product/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pr_detail}}</p>
            <p class="list-item-muted">{{item.pr_orispeccode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pr_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.pr_auditstatus=='未审核'}"
            >{{item.pr_auditstatus}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
      <add-button to="/document/product_edit" />
    </div>
    <div class="page page__list" v-if="isPC">
      <search-bar
        @search="onSearch"
        name="pc_code,pc_prcode_new,pc_prcode_old"
        placeholder="输入单号、新旧物料编号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/document/product_change/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pc_prcode_new}}</p>
            <p class="list-item-muted">{{item.pc_prcode_old}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pc_code}}</p>
            <span
              class="list-item-status"
              :class="{'warning':item.pc_status=='已审核'}"
            >{{item.pc_status}}</span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">共：{{items.length}}个</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    const me = this, beforeChange = me.beforeFilterChange
    return {
      isPC: false,
      listUrl: "/api/document/product/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "pr_auditstatuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "pr_auditstatuscode='AUDITED'"
            },
            {
              value: 3,
              label: "待变更",
              condition: "pc_statuscode='SUBMITTED'"
            },
            {
              value: 4,
              label: "已变更",
              condition: "pc_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      let isChange = filter.value > 2
      this.listUrl = isChange ? '/api/document/productchange/list' : '/api/document/product/list'
      // this.filters[0].name = isChange ? 'fixedassetschange.createTime' : 'fa_date'
      this.isPC = isChange ? true : false
      filterBar.initConfig()
      next()
    },
  }
};
</script>